/* KIVO — interacciones propias (vanilla, sin librerías) */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal, .mt-reveal--zoom');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { if (!el.classList.contains('mt-visible')) io.observe(el); });
  }

  function initParallax() {
    var imgs = document.querySelectorAll('[data-mt-parallax]');
    if (!imgs.length || reduceMotion || window.innerWidth < 990) return;
    var ticking = false;
    function update() {
      imgs.forEach(function (img) {
        var r = img.parentElement.getBoundingClientRect();
        var k = parseFloat(img.getAttribute('data-mt-parallax')) || 0;
        var off = (r.top + r.height / 2 - window.innerHeight / 2) * k * -0.01;
        img.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0) scale(1.12)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
    update();
  }

  function initGaleria() {
    document.querySelectorAll('[data-mt-galeria]').forEach(function (gal) {
      var principal = gal.querySelector('[data-mt-principal]');
      gal.querySelectorAll('[data-mt-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          gal.querySelectorAll('[data-mt-thumb]').forEach(function (b) { b.classList.remove('is-activa'); });
          btn.classList.add('is-activa');
          principal.style.opacity = 0;
          setTimeout(function () {
            principal.src = btn.getAttribute('data-src');
            principal.srcset = btn.getAttribute('data-srcset') || '';
            principal.alt = btn.getAttribute('data-alt') || '';
            principal.style.opacity = 1;
          }, 180);
        });
      });
    });
  }

  function formatMoney(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var miles = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var conComa = miles + ',' + parts[1];
    var conPunto = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return (fmt || '{{amount_with_comma_separator}} €')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, conComa)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, miles)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount\s*\}\}/, conPunto);
  }

  function initVariantes() {
    document.querySelectorAll('[data-mt-pdp]').forEach(function (pdp) {
      var dataEl = pdp.querySelector('[data-mt-variantes]');
      if (!dataEl) return;
      var data = JSON.parse(dataEl.textContent);
      var form = pdp.querySelector('form[action*="/cart/add"]');
      var idInput = form && form.querySelector('input[name="id"]');
      var btn = pdp.querySelector('[data-mt-boton]');
      var precio = pdp.querySelector('[data-mt-precio]');
      var tachado = pdp.querySelector('[data-mt-tachado]');
      var ahorro = pdp.querySelector('[data-mt-ahorro]');
      var aviso = pdp.querySelector('[data-mt-aviso]');

      function seleccion() {
        return Array.prototype.map.call(pdp.querySelectorAll('[data-mt-opcion]'), function (fs) {
          var c = fs.querySelector('input:checked');
          var sel = fs.querySelector('[data-mt-sel]');
          if (c && sel) sel.textContent = c.getAttribute('data-etiqueta') || c.value;
          return c ? c.value : null;
        });
      }

      function actualizar() {
        var opts = seleccion();
        var v = data.variants.find(function (x) {
          return x.options.every(function (o, i) { return o === opts[i]; });
        });
        if (!v) {
          btn.disabled = true; btn.querySelector('span').textContent = data.textos.no_disponible;
          if (aviso) aviso.hidden = false;
          return;
        }
        if (aviso) aviso.hidden = true;
        idInput.value = v.id;
        precio.textContent = formatMoney(v.price, data.formato);
        if (v.compare_at_price && v.compare_at_price > v.price) {
          tachado.textContent = formatMoney(v.compare_at_price, data.formato); tachado.hidden = false;
          if (ahorro) { ahorro.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; ahorro.hidden = false; }
        } else {
          tachado.hidden = true; if (ahorro) ahorro.hidden = true;
        }
        btn.disabled = !v.available;
        btn.querySelector('span').textContent = v.available ? data.textos.comprar : data.textos.agotado;
        if (v.featured_image && pdp.querySelector('[data-mt-principal]')) {
          var t = pdp.querySelector('[data-mt-thumb][data-media-id="' + v.featured_media_id + '"]');
          if (t) t.click();
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }

      pdp.querySelectorAll('[data-mt-opcion] input').forEach(function (i) { i.addEventListener('change', actualizar); });
      seleccion();
    });
  }

  function initCantidad() {
    document.querySelectorAll('[data-mt-cantidad]').forEach(function (box) {
      var input = box.querySelector('input');
      box.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(input.value, 10) || 1;
          n += b.getAttribute('data-paso') === '+' ? 1 : -1;
          input.value = Math.max(1, n);
        });
      });
    });
  }

  function init() { initReveal(); initParallax(); initGaleria(); initVariantes(); initCantidad(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
